import type { OrderExchangeStatus } from "../types";

// ADR-069-B Rule MKT-FE-03. Pure function exported separately (same
// convention as features/quality/components/RevisionStatusBadge.tsx's
// resolveRevisionLifecycleLabel) so it's independently testable.
export function resolveOrderStatusLabel(status: OrderExchangeStatus): {
  label: string;
  color: string;
} {
  switch (status) {
    case "created":
      return { label: "ثبت‌شده", color: "gray" };
    case "accepted":
      return { label: "پذیرفته‌شده", color: "blue" };
    case "rejected":
      return { label: "ردشده", color: "red" };
    case "fulfilled":
      return { label: "تکمیل‌شده", color: "green" };
    case "cancelled":
      return { label: "لغوشده", color: "darkGray" };
    default: {
      // Exhaustiveness guard — mirrors the "combination that should
      // never occur" fallback pattern used in Quality's badge.
      const _exhaustive: never = status;
      console.warn("Unknown OrderExchange status:", _exhaustive);
      return { label: String(status), color: "gray" };
    }
  }
}

export function OrderStatusBadge({ status }: { status: OrderExchangeStatus }) {
  const { label, color } = resolveOrderStatusLabel(status);
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: 12,
        fontSize: 12,
        color: "#fff",
        backgroundColor: color,
      }}
    >
      {label}
    </span>
  );
}
